const AUD = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
/** 105 -> "$1.05". Shared by the API and the SPA so a receipt cannot disagree with a cart. */
export function formatAud(cents) {
    return AUD.format(cents / 100);
}
/** 2000 -> "$20.00 each" */
export function formatPerUnit(cents) {
    return `${formatAud(cents)} each`;
}
/** 1 -> "1 unit", 23 -> "23 units". */
export function formatUnits(units) {
    return `${units} ${units === 1 ? 'unit' : 'units'}`;
}
/**
 * 10, 15000 -> "10 for $150.00".
 *
 * A pack is quoted as a total because that is the number the customer hands
 * over. It is deliberately never divided into a per-unit rate: the whole point
 * of the pack price is that it is set independently of the single price, so
 * "$15 each" would be a figure the shop neither stores nor charges.
 */
export function formatPack(packUnits, packPriceCents) {
    return `${packUnits} for ${formatAud(packPriceCents)}`;
}
//# sourceMappingURL=money.js.map